/*!
 * 週期視窗導航：「上 N 週 / 下 N 週」
 *
 * 選了 N 週套用後，一鍵把整個視窗往前/往後移 N 週（呼叫端自動套用、免再送出）。
 * 純展示元件；移動邏輯由 weekWindowUtils 的 windowNav 提供。
 *
 * 🔴 **刻意不用 reactstrap 的 `<Button>`。**
 *    black-dashboard 主題對 `.btn` 動了三件事：`:hover` 位移 −1px、
 *    `:active` 位移 +1px 並換 box-shadow、外加 `margin: 4px 1px` 與
 *    `overflow: hidden`。結果就是 Brad 2026-09-10 看到的
 *    「active / 停用 / 一般三個狀態大小會變」—— 位移加上陰影的有無，
 *    讀起來就像按鈕在縮放。用原生 <button> 才逃得掉那套規則。
 *
 * 🔑 **三個狀態的「量」完全一樣**：高度鎖 `HEIGHT`、`box-sizing: border-box`、
 *    邊框永遠 1px、永遠沒有 box-shadow、永遠沒有 transform。
 *    狀態差別只在**顏色與透明度**，所以不會有任何位移或尺寸變化。
 */
import React from "react";
import { COLORS } from "constant/adminTheme";

/** 這一整組週期控制項共用的高度（選擇器的 trigger 也用同一個） */
export const WEEK_CTRL_HEIGHT = 38;

const baseBtn = {
  height: WEEK_CTRL_HEIGHT,
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "0 13px",
  margin: 0,
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1,
  whiteSpace: "nowrap",
  background: COLORS.inputBg,
  transition: "background 0.16s ease, border-color 0.16s ease, color 0.16s ease",
};

function NavButton({ enabled, onClick, title, children }) {
  return (
    <button
      type="button"
      disabled={!enabled}
      onClick={() => enabled && onClick && onClick()}
      title={title}
      onMouseEnter={(e) => {
        if (!enabled) return;
        e.currentTarget.style.background = "rgba(17,205,239,0.12)";
        e.currentTarget.style.borderColor = COLORS.navActive;
      }}
      onMouseLeave={(e) => {
        if (!enabled) return;
        e.currentTarget.style.background = COLORS.inputBg;
        e.currentTarget.style.borderColor = COLORS.borderInput;
      }}
      style={{
        ...baseBtn,
        // 邊框寬度在三個狀態都是 1px —— 只換顏色，尺寸就不會跳
        border: `1px solid ${enabled ? COLORS.borderInput : COLORS.border}`,
        color: enabled ? COLORS.textPrimary : COLORS.textDimmed,
        cursor: enabled ? "pointer" : "not-allowed",
      }}
    >
      {children}
    </button>
  );
}

function TinyWeekWindowNav({ windowSize = 0, canEarlier, canLater, onEarlier, onLater, style }) {
  if (!windowSize) return null;
  return (
    <div style={{ display: "inline-flex", gap: 6, alignItems: "center", ...style }}>
      <NavButton enabled={!!canEarlier} onClick={onEarlier} title={`往前 ${windowSize} 週`}>
        <i className="fa fa-chevron-left" style={{ fontSize: 10 }} />上 {windowSize} 週
      </NavButton>
      <NavButton enabled={!!canLater} onClick={onLater} title={`往後 ${windowSize} 週`}>
        下 {windowSize} 週<i className="fa fa-chevron-right" style={{ fontSize: 10 }} />
      </NavButton>
    </div>
  );
}

export default TinyWeekWindowNav;
